// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"ContactInfo_infoContainer__15oF5","heading":"ContactInfo_heading__33J5I","contactLink":"ContactInfo_contactLink__y_TkB"};